import { render } from "./ventaserviciosextra.vue?vue&type=template&id=5675ae96&scoped=true"
import script from "./ventaserviciosextra.vue?vue&type=script&lang=js"
export * from "./ventaserviciosextra.vue?vue&type=script&lang=js"

import "./ventaserviciosextra.vue?vue&type=style&index=0&id=5675ae96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5675ae96"]])

export default __exports__